import { configureStore } from '@reduxjs/toolkit'
import streamsReducer from './streamsSlice'
import streamAnalysisReducer from './streamAnalysisSlice'
import wsReducer from './wsSlice'
import { wsMiddleware } from './wsMiddleware'

export const analysisStore = configureStore({
  reducer: {
    streams: streamsReducer,
    streamAnalysis: streamAnalysisReducer,
    ws: wsReducer,
  },
  middleware: (getDefault) => getDefault().concat(wsMiddleware),
})

export type AnalysisStore = typeof analysisStore
export type RootState = ReturnType<typeof analysisStore.getState>
export type AppDispatch = typeof analysisStore.dispatch
